import {
    SUBMIT_KITCHEN_ITEM,
    SUBMIT_KITCHEN_ITEM_SUCCESS,
    SUBMIT_KITCHEN_ITEM_ERROR
} from "./actionTypes"

export const submitKitchenItem = (addItem, history) =>{
    return{
        type: SUBMIT_KITCHEN_ITEM,
        payload:{ addItem, history },
    };
};

export const submitKitchenItemSuccess = (addItem) =>{
    return{
        type: SUBMIT_KITCHEN_ITEM_SUCCESS,
        payload:{ addItem },
    };
};

export const submitKitchenItemError = (error) =>{
    return{
        type: SUBMIT_KITCHEN_ITEM_ERROR,
        payload:{ error },
    };
}